import { createSlice } from "@reduxjs/toolkit";
import { getCurrentAndPreviousWeek } from "../../utils/utils";

const [today, previousWeekDate] = getCurrentAndPreviousWeek();

const initialState = {
  value: {
    startDate: previousWeekDate,
    endDate: today,
    isDefault: true
  },
};

const timeSheetDateRangeSlice = createSlice({
  name: "timeSheetDateRange",
  initialState,
  reducers: {
    setTimeSheetDateRange: (state, action) => {
      state.value = action.payload;
    },
  },
});

export const { setTimeSheetDateRange } = timeSheetDateRangeSlice.actions;
export default timeSheetDateRangeSlice.reducer;
